import axios from 'axios';
import Service from '@advisor/util/Service';

const {MS_BASE} = Service;

export default class AccountTransfer {
  static sendEmailRequest(payload) {
    return axios.post(
      `${MS_BASE}/v1/orchestrate/emails/adviser/${payload.riaUserId}/client/${payload.clientId}/${payload.templateName}`,
      payload
    );
  }
}
